@if (media) {
    <figure [attr.aria-label]="ariaLabel" [class.with-figure-caption]="showFigureCaption">
        @if (cta && !hasVideo) {
            <!-- Image with CTA -->
            <a
                [attr.aria-label]="linkAriaLabel"
                (click)="mediaRedirection($event, cta)"
                [href]="cta.path"
                class="media-link"
                data-cta-spa
                [class.keyboard-navigation]="isKeyboardNavigation$ | async">
                <ng-template [ngTemplateOutlet]="mediaTemplate"></ng-template>
            </a>
        } @else {
            <!-- Video (with or without CTA) or image without CTA -->
            <ng-template [ngTemplateOutlet]="mediaTemplate"></ng-template>
        }
        @if (showFigureCaption) {
            <h-media-captions [media]="media"></h-media-captions>
        }
    </figure>
}

<ng-template #mediaTemplate>
    <div class="media-container" [class.is-fill-mode]="isFillMode">
        @if (videoUrl && media) {
            <h-video
                [showMuteButtons]="showSoundControlButton"
                [displayGradient]="displayGradient"
                [isLightMode]="isLightMode"
                [videoUrl]="videoUrl"
                [mobileVideoUrl]="mobileVideoUrl"
                [alwaysShowControls]="media.alwaysShowControls"
                [videoLoopMuteAutoplay]="media.videoLoopMuteAutoplay"
                [videoRatio]="videoRatio"
                [videoName]="mediaName"
                [isFillMode]="isFillMode"
                [class.fill-mode]="isFillMode">
                <h-media-picture
                    class="poster-video"
                    [mediaPicture]="media"
                    [preloadPoster]="preloadPoster"
                    [mediaQueriesOptions]="mediaOptions"
                    [title]="title"></h-media-picture>
            </h-video>
        } @else {
            <h-media-picture
                [mediaPicture]="media"
                [preloadPoster]="preloadPoster"
                [mediaQueriesOptions]="mediaOptions"
                [title]="title"></h-media-picture>
        }
        <ng-content></ng-content>
    </div>
</ng-template>
